import React, { useEffect, useState } from 'react';
import { Tooltip } from 'antd';
import { fetchMcCompanyLogoUrl } from '../services/mysteryClientService';
import '../styles/GeoJson.css';

/**
 * Company logo from mystery_client uploads (clients.json → logoFile).
 * Always mounts the container once the fetch settles (shows nothing only while loading).
 */
function McClientLogo({ onClick, style }) {
  const [logoUrl, setLogoUrl] = useState(null);
  const [ready, setReady] = useState(false);
  const company = localStorage.getItem('company') || localStorage.getItem('client_type') || 'Client';

  useEffect(() => {
    let blobUrl = null;
    let cancelled = false;
    const companyName = localStorage.getItem('company') || 'ATB';
    console.log('[MC Logo] Fetching logo for company:', companyName);
    fetchMcCompanyLogoUrl(companyName)
      .then((url) => {
        if (cancelled) {
          if (url) URL.revokeObjectURL(url);
          return;
        }
        if (url) {
          blobUrl = url;
          setLogoUrl(url);
          console.log('[MC Logo] Logo loaded');
        } else {
          console.warn('[MC Logo] No logo URL returned for', companyName);
        }
      })
      .catch((err) => console.warn('[MC Logo] Could not load company logo:', err))
      .finally(() => {
        if (!cancelled) setReady(true);
      });
    return () => {
      cancelled = true;
      if (blobUrl) URL.revokeObjectURL(blobUrl);
    };
  }, []);

  if (!ready || !logoUrl) return null;

  return (
    <Tooltip
      title={company.replace(/_/g, ' ').toUpperCase()}
      placement="bottomRight"
    >
      <div
        className="traffix-logo-container"
        style={{ position: 'fixed', zIndex: 1000001, ...style }}
        onClick={onClick}
      >
        <img src={logoUrl} alt="Logo" className="betwin-logo-img" />
      </div>
    </Tooltip>
  );
}

export default McClientLogo;
